import { createContext, useContext } from 'react';
export const CloneProductActionContext = /*#__PURE__*/createContext(undefined);
export const useCloneProductAction = () => {
  const context = useContext(CloneProductActionContext);
  if (context === undefined) {
    throw new Error('CloneProductActionContext data is undefined. useCloneProductAction must be used within a CloneProductActionContext.Provider');
  }
  return context;
};